import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  notificationIcon: {
    color: theme.palette.primary.contrastText,
    fontSize: '30px',
  },
  notificationsCount: {
    height: '20px',
    position: 'absolute',
    top: '-5px',
    left: '10px',
    display: 'flex',
    justifyContent: 'center',
    background: theme.palette.error.main,
    fontWeight: 700,
    fontSize: '14px',
    color: 'white',
    borderRadius: '10px',
    minWidth: '30px',
    padding: '0 3px',
  },
}));

type PNotificationIcon = {
  notificationsCount?: number;
  className?: any;
  style?: any;
  onClick?: any;
};

export const NotificationIcon: React.FC<PNotificationIcon> = (props) => {
  const { notificationsCount, className, style, onClick } = props;
  const classes = useStyles();
  return (
    <div
      className={clsx(classes.root, className)}
      style={style}
      onClick={onClick}
    >
      <NotificationsIcon className={classes.notificationIcon} />
      {Boolean(notificationsCount) && (
        <div className={classes.notificationsCount}>{notificationsCount}</div>
      )}
    </div>
  );
};
